import { PageContent } from '@/shared/components/PageContent';
import { CreditSummarySection } from '@/features/credits/components/CreditSummarySection';
import { LinkedAccountSection } from '@/features/credits/components/LinkedAccountSection';
import { MakePaymentModal } from '@/features/credits/components/MakePaymentModal';
import { PeriodSummarySection } from '@/features/credits/components/PeriodSummarySection';
import { StatementsSection } from '@/features/credits/components/StatementsSection';
import { useCredits } from '@/features/credits/hooks/useCredits';
import styles from './CreditsPage.module.css';
import { t } from '@/i18n';

export default function CreditsPage() {
  const {
    creditSummary,
    periodSummary,
    linkedAccount,
    isPaymentModalOpen,
    isConfirmingPayment,
    pagination,
    statements,
    handleMakePayment,
    handleClosePaymentModal,
    handleConfirmPayment,
    handleDownloadStatement,
  } = useCredits();

  return (
    <PageContent
      title={t('credits.pageTitle')}
    >
      <div className={styles.page}>
        {creditSummary && (
          <CreditSummarySection
            data={creditSummary}
            onMakePayment={handleMakePayment}
          />
        )}
        {linkedAccount && <LinkedAccountSection data={linkedAccount} />}
        {periodSummary && <PeriodSummarySection data={periodSummary} />}
        <StatementsSection
          statements={statements}
          pagination={pagination}
          onDownloadStatement={handleDownloadStatement}
        />
      </div>
      {creditSummary && linkedAccount && (
        <MakePaymentModal
          isOpen={isPaymentModalOpen}
          onClose={handleClosePaymentModal}
          amount={creditSummary.toPayAmount}
          linkedAccount={linkedAccount}
          onConfirm={handleConfirmPayment}
          isConfirming={isConfirmingPayment}
        />
      )}
    </PageContent>
  );
}

export { CreditsPage };
